// extracted by mini-css-extract-plugin
export default {"cls1":"AddPayeeError-OnBoardError_cls1__WvX1W","cls2":"AddPayeeError-OnBoardError_cls2__BAIrc AddPayeeError-OnBoardError_cls1__WvX1W"};